import { css } from "lit";

export const styles = css`
  :host {
    --min-width: var(--size-60);
  }

  .table {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    color: var(--color-black);
    border-collapse: collapse;
    background-color: var(--color-white);
    border: 1px solid var(--color-neutral-10);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: inset 0px 0px 0px 2px var(--color-neutral-10);
    font-size: 16px;
    line-height: var(--line-height-snug);
    min-width: var(--min-width);
  }

  table th {
    font-weight: 600;
    background-color: var(--color-neutral-10);
    color: var(--color-black);
    box-shadow: inset 0px 0px 0px 2px var(--color-neutral-10);
    padding: 16px 12px;
    text-align: left;
    vertical-align: center;
  }

  table td {
    color: var(--color-black);
    padding: 12px;
    text-align: left;
    vertical-align: top;
    border: 2px solid var(--color-neutral-10);
  }

  table td img {
    object-fit: cover;
  }

  a {
    color: var(--color-black);
  }

  table caption {
    display: none;
  }

  table tfoot td {
    font-size: var(--font-size-xs);
    color: var(--color-gray);
  }

  table tfoot a {
    color: var(--color-gray);
  }
`;
